import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { NotificationDto, NotificationRequest } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/notifications`;

export const getAllNotifications = (source: CancelTokenSource): Promise<NotificationDto[]> => {
  return axios
      .get(`${apiUri}`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const searchNotifications = (request: Partial<NotificationRequest>, source: CancelTokenSource)
    : Promise<NotificationDto[]> => {
  return axios
      .post(`${apiUri}/search`, request, {cancelToken: source.token})
      .then((response) => response.data);
};

export const updateNotifyEmails = (
    id: number, notifyEmails: string, source: CancelTokenSource)
    : Promise<NotificationDto> => {

  const formData = new FormData();
  formData.set("notifyEmails", notifyEmails);

  return axios
      .post(`${apiUri}/${id}/notify-emails`, formData, {cancelToken: source.token})
      .then((response) => response.data);
};

export const downloadFileFromFileArchiveId = (
    notificationId: number,
    source: CancelTokenSource): Promise<any> => {
  return axios
      .get(`${apiUri}/download/${notificationId}`, {cancelToken: source.token})
      .then(response => {
        const type = response.headers['content-type'];
        // @ts-ignore
        const BOM = new Uint8Array([0xEF, 0xBB, 0xBF]);
        const blob = new Blob([BOM, response.data], {type: type});
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = response.headers['content-disposition'];
        const filenameRegex = /filename=(.*)/;
        const regexResponse = filenameRegex.exec(link.download);
        const defaultFileName = "response.csv";
        const fileName = regexResponse ?
            regexResponse[1] ? regexResponse[1] : defaultFileName :
            defaultFileName;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        return true;
      });
};

export const generate = (
    request: Partial<NotificationRequest>,
    mandateId: number,
    source: CancelTokenSource): Promise<String> => {
  return axios
      .post(`${apiUri}/generate`, request, {params: {mandateId: mandateId}, cancelToken: source.token})
      .then((response) => response.data);
};
